import React from "react";
import { CaretDown } from "@phosphor-icons/react";
import styles from "./Tooltip.module.css";
import { ITooltip } from "../../models/ITooltip";

enum arrowPosition {
	"none" = "none",
	"top-left" = "bottom-right",
	"top-right" = "bottom-left",
	"top-center" = "bottom-center",
	"bottom" = "top-center",
	"left" = "right",
	"right" = "left"
}
const Tooltip: React.FC<ITooltip> = (props: ITooltip) => {
	const { position = "left", width = "max-content", maxWidth = "50vw", className = "" } = props;
	return (
		<div className={styles.tooltip_cont}>
			<div className={styles.tooltip_icon}>{props.children || <i className={`ph ph-question ${styles.form_field_info_icon}`}></i>}</div>
			<div style={{ width: width, maxWidth: maxWidth }} className={`${styles.tooltip_popup} ${styles["position_" + position]} ${className}`}>
				{typeof props.label === "string" ? (
					<div className="">
						<div className={styles.tooltip_text}>{props.label}</div>
						{props.supportingText && <div className={styles.tooltip_supporting_text}>{props.supportingText}</div>}
					</div>
				) : (
					props.label
				)}
				<CaretDown className={styles["arrow_position_" + arrowPosition[position]]} weight="fill" />
			</div>
		</div>
	);
};

export default Tooltip;
